import { useDisclosure } from '@chakra-ui/react'
import { ItList } from 'types/graphql'

import useDeleteItList from 'src/lib/hooks/mutations/useDeleteItList'

export default function useDeleteItListMenuItem(
  itList: Pick<ItList, 'id' | 'status'>,
  onDeleted: () => void,
  closeMenu: () => void
) {
  const { isOpen, onOpen: openModal, onClose: closeModal } = useDisclosure()
  const onClose = () => {
    closeMenu()
    closeModal()
  }
  const onOpen: React.MouseEventHandler = (ev) => {
    ev.stopPropagation()
    ev.preventDefault()
    openModal()
  }

  const [deleteItListMutation] = useDeleteItList()

  const onConfirm = () => {
    deleteItListMutation({
      variables: { id: itList.id },
      onCompleted: async () => {
        onDeleted()
      },
    })
  }
  return { isOpen, onClose, onOpen, onConfirm }
}
